import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconPin = () => {
  return (
    <g>
      <path
        d="M13.632 4a1.255 1.255 0 0 1-.355 2.024l-.135.054-1.401.467-.057.026-.05.04-2.096 2.096.042.137c.149.555.221 1.127.215 1.702l-.013.344-.031.344c-.032.266-.163.604-.401 1.056l-.11.201-.226.394-.27.443a1.146 1.146 0 0 1-1.577.371l-.108-.076-.099-.088-2.669-2.67-2.894 2.895a.819.819 0 0 1-1.23-1.074l.073-.083 2.893-2.895L.47 7.046a1.146 1.146 0 0 1-.083-1.528l.083-.093.108-.095.118-.08.476-.277c.825-.466 1.388-.708 1.793-.744a6.304 6.304 0 0 1 1.923.126l.312.078.095.027L7.41 2.342l.018-.026.026-.057.467-1.4A1.255 1.255 0 0 1 9.892.27L10 .368 13.632 4zM12 4.765 9.23 2l-.273.818c-.056.17-.136.33-.236.476l-.107.141-.12.132-2.845 2.841-.501-.196a4.683 4.683 0 0 0-2.116-.302l-.025.004-.073.021-.212.087-.303.147L2 6.392 7.616 12l.214-.38.113-.215.077-.163.042-.107.008-.032c.08-.669.016-1.348-.19-1.988l-.097-.271-.196-.5 2.845-2.842c.168-.169.366-.304.583-.399l.167-.064.818-.274z"
        
      />
    </g>
  );
};


export default withIcon(IconPin);
